/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Company_PlaceholderInputs */

const en_salary_negotiate_company_placeholder = /** @type {(inputs: Salary_Negotiate_Company_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Siemens`)
};

const de_salary_negotiate_company_placeholder = /** @type {(inputs: Salary_Negotiate_Company_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Siemens`)
};

const fr_salary_negotiate_company_placeholder = /** @type {(inputs: Salary_Negotiate_Company_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. Siemens`)
};

const es_salary_negotiate_company_placeholder = /** @type {(inputs: Salary_Negotiate_Company_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. Siemens`)
};

const it_salary_negotiate_company_placeholder = /** @type {(inputs: Salary_Negotiate_Company_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. Siemens`)
};

const nl_salary_negotiate_company_placeholder = /** @type {(inputs: Salary_Negotiate_Company_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bijv. Siemens`)
};

const pl_salary_negotiate_company_placeholder = /** @type {(inputs: Salary_Negotiate_Company_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`np. Siemens`)
};

const fi_salary_negotiate_company_placeholder = /** @type {(inputs: Salary_Negotiate_Company_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`esim. Siemens`)
};

const da_salary_negotiate_company_placeholder = /** @type {(inputs: Salary_Negotiate_Company_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`f.eks. Siemens`)
};

const sv_salary_negotiate_company_placeholder = /** @type {(inputs: Salary_Negotiate_Company_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`t.ex. Siemens`)
};

/**
* | output |
* | --- |
* | "e.g. Siemens" |
*
* @param {Salary_Negotiate_Company_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_company_placeholder = /** @type {((inputs?: Salary_Negotiate_Company_PlaceholderInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Company_PlaceholderInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_company_placeholder(inputs)
	if (locale === "fr") return fr_salary_negotiate_company_placeholder(inputs)
	if (locale === "es") return es_salary_negotiate_company_placeholder(inputs)
	if (locale === "it") return it_salary_negotiate_company_placeholder(inputs)
	if (locale === "nl") return nl_salary_negotiate_company_placeholder(inputs)
	if (locale === "pl") return pl_salary_negotiate_company_placeholder(inputs)
	if (locale === "fi") return fi_salary_negotiate_company_placeholder(inputs)
	if (locale === "da") return da_salary_negotiate_company_placeholder(inputs)
	if (locale === "sv") return sv_salary_negotiate_company_placeholder(inputs)
	return en_salary_negotiate_company_placeholder(inputs)
});